import * as Schema from "effect/Schema";
import { countGraphemes } from "unicode-segmenter/grapheme";
import { IsoDateTime, MessageId, PositiveInt } from "./baseSchemas.ts";

export const MAX_MESSAGE_REACTIONS = 20;

/**
 * W-32246044: why a Send (or a correction) that carries a reaction is
 * refused. Written for people (commandRefusal.ts): it says only what is true
 * wherever it is refused, since the refused Send saves no reaction.
 */
export const REACTION_IS_NOT_A_MESSAGE =
  "A reaction on Cleo's reply is never sent to her as a message, so this was not sent. React on the reply instead, or type your answer to send one.";

/** One native emoji, including a flag, keycap, skin tone or joined family. */
export function isMessageReactionEmoji(value: string): boolean {
  return (
    value.length > 0 &&
    value.length <= 64 &&
    countGraphemes(value) === 1 &&
    /[\p{Extended_Pictographic}\p{Regional_Indicator}\u20e3]/u.test(value)
  );
}

export const MessageReactionEmoji = Schema.String.check(
  Schema.makeFilter((value) => isMessageReactionEmoji(value) || "Choose one emoji."),
);

export const MessageReactionState = Schema.Struct({
  emojis: Schema.Array(MessageReactionEmoji).check(Schema.isMaxLength(MAX_MESSAGE_REACTIONS)),
  revision: PositiveInt,
  updatedAt: IsoDateTime,
});
export type MessageReactionState = typeof MessageReactionState.Type;

/**
 * What an older Desk copied onto a message it sent. Kept only so those stored
 * messages still read; nothing writes it now (W-32246044: Cleo is not told
 * about reactions in any form).
 */
export const MessageReactionContext = Schema.Struct({
  messageId: MessageId,
  messageText: Schema.String,
  reactions: MessageReactionState,
  reply: Schema.Boolean,
});
export type MessageReactionContext = typeof MessageReactionContext.Type;

export const MessageReactionReply = Schema.Struct({
  messageId: MessageId,
  emoji: MessageReactionEmoji,
});
export type MessageReactionReply = typeof MessageReactionReply.Type;
